import { createStore } from "vuex";

import auth from "./modules/auth";
import application from "./modules/application";
import notification from "./modules/notification";
import profile from "./modules/profile";
import serviceAccount from "./modules/service-account";
import asigProject from "./modules/asig-project";
import emailVerification from "./modules/email-verification";

export default createStore({
  modules: {
    application,
    auth,
    notification,
    profile,
    "service-account": serviceAccount,
    "asig-project": asigProject,
    "email-verification": emailVerification,
  },
});
